var classes = {"tabNavigationHorizontal":"VcjZ0","tabNavigationHorizontalCenter":"uBoKP","underline":"yyQEp"};

export { classes as default };
